export default "__VITE_ASSET__BDMPBhKU__"